export enum JobState {
  UNSTARTED = 'UNSTARTED',
  COMPLETED_WITH_ERROR = 'COMPLETED_WITH_ERROR',
  COMPLETED = 'COMPLETED',
}
